<template>
  <section class="hero-carousel">
    <div v-for="(banner, index) in banners" :key="index" class="hero-slide" :class="{ active: index === currentIndex }">
      <div v-for="(banner, index) in banners" :key="index" class="hero-slide"
        :class="{ active: index === currentIndex }">
        <!-- Banner clicável apenas no primeiro -->
        <a v-if="index === 0" href="https://pos.faculdadealfamerica.edu.br/empreender" target="_blank"
          rel="noopener noreferrer">
          <picture class="hero-image">
            <source media="(max-width: 768px)" :srcset="banner.mobileSrc" />
            <img :src="banner.src" :alt="banner.alt" />
          </picture>
        </a>

        <!-- Banner normal para os demais -->
        <picture v-else class="hero-image">
          <source media="(max-width: 768px)" :srcset="banner.mobileSrc" />
          <img :src="banner.src" :alt="banner.alt" />
        </picture>
      </div>


    </div>

    <button id="btn-play" class="hero-control" @click="toggleAutoPlay">
      <img :src="isAutoPlaying
        ? require('@/assets/img/icons/pause.svg')
        : require('@/assets/img/icons/play.svg')" />
    </button>
  </section>
</template>

<script>
export default {
  name: "CarrosselHero",

  data() {
    return {
      banners: [
        {
          src: require("@/assets/img/banner-promo-btn.png"),
          mobileSrc: require("@/assets/img/banner-mobile.png"),
          alt: "Banner Preços",
        },
        {
          src: require("@/assets/img/banner-com-logo.png"),
          mobileSrc: require("@/assets/img/fundo-mobile.png"),
          alt: "Banner Logo",
        },
      ],
      currentIndex: 0,
      isAutoPlaying: true,
      interval: null,
    };
  },

  mounted() {
    this.start();
  },

  beforeDestroy() {
    this.stop();
  },

  methods: {
    start() {
      this.stop();
      this.interval = setInterval(() => {
        this.currentIndex =
          (this.currentIndex + 1) % this.banners.length;
      }, 8000);
    },

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },

    toggleAutoPlay() {
      this.isAutoPlaying = !this.isAutoPlaying;
      this.isAutoPlaying ? this.start() : this.stop();
    },
  },
};
</script>

<style>
.hero-carousel {
  position: relative;
  width: 100vw;
  min-height: 30vh;
  overflow: hidden;
}

.hero-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.hero-slide.active {
  opacity: 1;
  z-index: 1;
}

.hero-image,
.hero-image img {
  width: 100%;
  height: auto;
  display: block;
}

.hero-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
  display: flex;
  align-items: flex-end;
}

.hero-content {
  padding: 3rem;
  color: white;
}

.hero-control {
  position: absolute;
  bottom: 24px;
  right: 24px;
  z-index: 10;
  background: white;
  color: #212B55;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

/* botão de play e pause */
#btn-play {
  border-radius: 50%;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border: 2px solid white;
  background-color: #B7182E;
  opacity: .7;
  transition: opacity 500ms ease-in-out;

  & img {
    width: 1.2rem;
    height: 1.2rem;
  }

  &:hover {
    opacity: 1;
  }
}


/* celular */
@media (max-width: 576px) {
  .hero-carousel {
    height: 90vh;
  }
}

/* tablet */
@media (min-width: 577px) and (max-width: 768px) {
  .hero-carousel {
    height: 110vh;
  }
}

/* notebook */
@media (min-width: 769px) and (max-width: 1080px) {
  .hero-carousel {
    height: 20rem;
  }
}

/* desktop 1 */
@media (min-width: 1081px) and (max-width: 1284px) {
  .hero-carousel {
    height: 25rem;
  }
}

/* desktop 2 */
@media (min-width: 1285px) and (max-width: 1500px) {
  .hero-carousel {
    height: 30rem;
  }
}

/* desktop 3 */
@media (min-width: 1501px) and (max-width: 1700px) {
  .hero-carousel {
    height: 35rem;
  }
}

/* desktop 4 */
@media (min-width: 1701px) {
  .hero-carousel {
    height: 42rem;

    max-width: 2000px;
    margin: 0 auto;
  }

  .hero-slide {
    inset: 0;
  }

  .hero-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>